/**
 * @generated SignedSource<<664f33157b0348f4d543ab06c4b8b42a>>
 * @relayHash d5a8635588991f154c1e7912f7284204
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74657f4e43888ea31ee636aa6bebf881cc1e1a909af0f040209d3f269c524b11

import type { ConcreteRequest } from 'relay-runtime';
export type AgentStudioAgentCreatorType = "CUSTOMER" | "FORGE" | "GUIDED" | "OOTB" | "REMOTE_A2A" | "ROVO_CHAT" | "ROVO_DEV" | "%future added value";
export type queryAgentMentionsForInitialStateQuery$variables = {
  cloudId: string;
  creatorTypes?: ReadonlyArray<AgentStudioAgentCreatorType> | null;
  first?: number | null;
  includeMyAgents: boolean;
  includeRovoChatAgent: boolean;
  product?: string | null;
};
export type queryAgentMentionsForInitialStateQuery$data = {
  readonly allAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly favoriteAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly myAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly rovoChatAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly verifiedAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
};
export type queryAgentMentionsForInitialStateQuery = {
  response: queryAgentMentionsForInitialStateQuery$data;
  variables: queryAgentMentionsForInitialStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creatorTypes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMyAgents"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRovoChatAgent"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v8 = [
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "creatorTypes",
        "variableName": "creatorTypes"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "creatorType"
},
v11 = {
  "kind": "ScalarField",
  "name": "description"
},
v12 = {
  "kind": "ScalarField",
  "name": "picture"
},
v13 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v12/*: any*/)
            ]
          },
          (v13/*: any*/),
          (v14/*: any*/)
        ]
      }
    ]
  }
],
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v17 = {
  "kind": "Variable",
  "name": "includeRovoChatAgent",
  "variableName": "includeRovoChatAgent"
},
v18 = [
  (v6/*: any*/),
  (v16/*: any*/),
  {
    "fields": [
      (v17/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyFavouriteAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v7/*: any*/)
],
v19 = [
  (v6/*: any*/),
  (v16/*: any*/),
  {
    "fields": [
      (v17/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyMyAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v7/*: any*/)
],
v20 = [
  (v6/*: any*/),
  (v16/*: any*/),
  {
    "fields": [
      (v17/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyVerifiedAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v7/*: any*/)
],
v21 = [
  (v6/*: any*/),
  (v16/*: any*/),
  {
    "fields": [
      (v17/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v7/*: any*/)
],
v22 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v12/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v13/*: any*/),
          (v14/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "condition": "includeRovoChatAgent",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "rovoChatAgents",
            "args": (v8/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v15/*: any*/)
          }
        ]
      },
      {
        "alias": "favoriteAgents",
        "args": (v18/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v15/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v19/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v15/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v20/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v15/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v21/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v15/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "condition": "includeRovoChatAgent",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "rovoChatAgents",
            "args": (v8/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v22/*: any*/)
          }
        ]
      },
      {
        "alias": "favoriteAgents",
        "args": (v18/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v22/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v19/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v22/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v20/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v22/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v21/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v22/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "d5a8635588991f154c1e7912f7284204",
    "id": "74657f4e43888ea31ee636aa6bebf881cc1e1a909af0f040209d3f269c524b11",
    "metadata": {},
    "name": "queryAgentMentionsForInitialStateQuery",
    "operationKind": "query",
    "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$includeMyAgents:Boolean!,$includeRovoChatAgent:Boolean!,$product:String,$creatorTypes:[AgentStudioAgentCreatorType!]){rovoChatAgents:agentStudio_getAgents(cloudId:$cloudId,first:1,input:{creatorTypes:$creatorTypes},product:$product)@include(if:$includeRovoChatAgent)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},myAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyMyAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@include(if:$includeMyAgents)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
  }
};
})();

(node as any).hash = "b7d4986a79659ed0d5512417992bd25f";

export default node;
